import {Injectable, NgZone} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SessionService} from './session.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../app/app.state';
import {NativeMobileService} from './native-mobile.service';
import {App} from '@capacitor/app';
import {PushNotifications} from '@capacitor/push-notifications';
import {StatusBar} from '@capacitor/status-bar';
import {AlarmsService} from './alarms.service';
import {UrlService} from './url.service';

@Injectable({
  providedIn: 'root',
})
export class NativeAndroidService extends NativeMobileService {
  constructor(
    protected http: HttpClient,
    protected session: SessionService,
    protected store: Store<AppState>,
    protected alarmsService: AlarmsService,
    protected urlService: UrlService,
    protected ngZone: NgZone,
  ) {
    super(http, session, store, alarmsService, urlService, ngZone);
  }


  afterDeviceInfoLoaded() {
    StatusBar.setBackgroundColor({
      color: '#27333a',
    });

    App.addListener('backButton', () => {
      window.history.back();
    });

    PushNotifications.createChannel({
      id: 'new_event',
      importance: 4,
      name: 'Alarm Event Started',
      description: 'A new alarm event has started and has not yet been acknowledged.',
      sound: 'pushbeep.mp3',
    });

    PushNotifications.createChannel({
      id: 'ack_event',
      importance: 4,
      name: 'Alarm Acknowledged',
      description: 'An alarm has been acknowledged.',
      sound: 'pushneutral.mp3',
    });

    PushNotifications.createChannel({
      id: 'clear_event',
      importance: 4,
      name: 'Alarm Cleared',
      description: 'An alarm has been cleared.',
      sound: 'pushfixed.mp3',
    });
  }
}
